<template>
  <div>
    <v-container
      v-if="isPreparingCompany"
      class="py-8"
    >
      <v-progress-linear
        indeterminate
        color="primary"
      />
    </v-container>
    <v-alert
      v-else-if="companyLoadError"
      dense
      text
      type="error"
      class="ma-4"
    >
      {{ companyLoadError }}
    </v-alert>
    <template v-else>
      <kiosk-qr-provisioning v-if="isSuperUser" />
      <company-provisioning-qr-dialog
        v-else
        v-model="dialog"
        :company="selectedCompany"
      />
    </template>
  </div>
</template>

<script>
  import KioskQrProvisioning from './components/KioskQrProvisioning.vue'
  import CompanyProvisioningQrDialog from './components/CompanyProvisioningQrDialog.vue'

  export default {
    name: 'KioskQrProvisioningView',

    components: {
      KioskQrProvisioning,
      CompanyProvisioningQrDialog,
    },

    data: () => ({
      dialog: true,
      isPreparingCompany: false,
      companyLoadError: '',
    }),

    computed: {
      isSuperUser () {
        return this.$store.getters['authUser/isSuperUser']
      },
      selectedCompanyId () {
        return this.$store?.state?.company?.selectedCompanyId || 0
      },
      selectedCompany () {
        const company = this.$store?.state?.company?.companies?.[this.selectedCompanyId] || {}

        return {
          ...company,
          id: company.id || this.selectedCompanyId,
          name: company.name || this.$store?.state?.company?.selectedCompanyName || '',
        }
      },
    },

    created () {
      this.ensureSelectedCompany()
    },

    watch: {
      // Non-super users see only the lightweight provisioning dialog here.
      // Closing it should take them back to the main app rather than leaving
      // an empty page behind.
      dialog (val) {
        if (!val && !this.isSuperUser) {
          this.$router.push('/devices')
        }
      },
    },

    methods: {
      async ensureSelectedCompany () {
        const companyById = this.$store?.state?.company?.companies || {}

        if (this.selectedCompanyId && companyById[this.selectedCompanyId]) {
          return
        }

        this.isPreparingCompany = true
        this.companyLoadError = ''

        try {
          const companies = await this.$store.dispatch('company/loadCompanies', 0)
          const currentCompanyId = this.$store.getters['authUser/currentCompanyId']
          const loadedCompanyById = this.$store?.state?.company?.companies || {}
          const fallbackCompany = companies[0]
          const selectedCompany =
            loadedCompanyById[this.selectedCompanyId] ||
            loadedCompanyById[currentCompanyId] ||
            fallbackCompany

          if (!this.selectedCompanyId && selectedCompany?.id) {
            await this.$store.dispatch('company/selectCompany', selectedCompany.id)
          } else if (!this.selectedCompanyId) {
            this.companyLoadError = 'No company is available for QR provisioning.'
          }
        } catch (error) {
          this.companyLoadError =
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            'Could not load company details for QR provisioning.'
        } finally {
          this.isPreparingCompany = false
        }
      },
    },
  }
</script>
